window.theme = window.theme || {};

theme.config = {
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
};

theme.delegate = {
  on: function(event, callback, options){
    if( !this.namespaces ) // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split('.')[0], callback, options);
    return this;
  },
  off: function(event) {
    if (!this.namespaces) { return }
    this.removeEventListener(event.split('.')[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  }
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;

theme.a11y = {
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter(el => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    document.documentElement.off('focusin');
    document.documentElement.on(eventsName.focusout, function() {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.container) {
      options.container.removeAttribute('tabindex');
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function(namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add('lock-scroll');
    el.on('touchmove' + namespace, function() {
      return true;
    });
  },

  unlockMobileScrolling: function(namespace, element) {
    document.documentElement.classList.remove('lock-scroll');
    var el = element ? element : document.documentElement;
    el.off('touchmove' + namespace);
  }
};

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    vimeo: {
      tagId: 'vimeo-api',
      src: 'https://player.vimeo.com/api/player.js',
      type: types.script
    },
    shopifyXr: {
      tagId: 'shopify-model-viewer-xr',
      src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
      type: types.script
    },
    modelViewerUi: {
      tagId: 'shopify-model-viewer-ui',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
      type: types.script
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


// Video modal will auto-initialize for any anchor link that points to YouTube
// MP4 videos must manually be enabled with:
//   - .product-video-trigger--mp4 (trigger button)
//   - .product-video-mp4-sound video player element (cloned into modal)
//     - see media.liquid for example of this
theme.videoModal = function() {
  var youtubePlayer;

  var videoHolderId = 'VideoHolder';
  var selectors = {
    youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
    mp4Trigger: '.product-video-trigger--mp4',
    mp4Player: '.product-video-mp4-sound'
  };

  var youtubeTriggers = document.querySelectorAll(selectors.youtube);
  var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

  if (!youtubeTriggers.length && !mp4Triggers.length) {
    return;
  }

  var videoHolderDiv = document.getElementById(videoHolderId);

  if (youtubeTriggers.length) {
    theme.LibraryLoader.load('youtubeSdk');
  }

  var modal = new theme.Modals('VideoModal', 'video-modal', {
    closeOffContentClick: true,
    bodyOpenClass: ['modal-open', 'video-modal-open'],
    solid: true
  });

  youtubeTriggers.forEach(btn => {
    btn.addEventListener('click', triggerYouTubeModal);
  });

  mp4Triggers.forEach(btn => {
    btn.addEventListener('click', triggerMp4Modal);
  });

  document.addEventListener('modalClose.VideoModal', closeVideoModal);

  function triggerYouTubeModal(evt) {
    // If not already loaded, treat as normal link
    if (!theme.config.youTubeReady) {
      return;
    }

    evt.preventDefault();
    emptyVideoHolder();

    modal.open(evt);

    var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
    youtubePlayer = new theme.YouTube(
      videoHolderId,
      {
        videoId: videoId,
        style: 'sound',
        events: {
          onReady: onYoutubeReady
        }
      }
    );
  }

  function triggerMp4Modal(evt) {
    emptyVideoHolder();

    var el = evt.currentTarget;
    var player = el.parentNode.querySelector(selectors.mp4Player);

    // Clone video element and place it in the modal
    var playerClone = player.cloneNode(true);
    playerClone.classList.remove('hide');

    videoHolderDiv.append(playerClone);
    modal.open(evt);

    // Play new video element
    videoHolderDiv.querySelector('video').play();
  }

  function onYoutubeReady(evt) {
    evt.target.unMute();
    evt.target.playVideo();
  }

  function getYoutubeVideoId(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }

  function emptyVideoHolder() {
    videoHolderDiv.innerHTML = '';
  }

  function closeVideoModal() {
    if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
      youtubePlayer.destroy();
    } else {
      emptyVideoHolder();
    }
  }
};


theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: ['modal-open'],
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.modal = document.getElementById(id);

    if (!this.modal) {
      return false;
    }

    this.modalContent = this.modal.querySelector('.modal__inner');

    this.config = Object.assign(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    document.querySelectorAll(this.config.open).forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', this.open.bind(this));
    });

    this.modal.querySelectorAll(this.config.close).forEach(btn => {
      btn.addEventListener('click', this.close.bind(this));
    });

    // Close modal if a drawer is opened
    document.addEventListener('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.modal.classList.add(this.config.openClass);

    document.documentElement.classList.add(...this.config.bodyOpenClass);

    if (this.isSolid) {
      document.documentElement.classList.add(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    theme.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen,
      namespace: 'modal_focus'
    });

    document.dispatchEvent(new CustomEvent('modalOpen'));
    document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

    this.bindEvents();
  };

  Modal.prototype.close = function(evt) {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // Do not close modal if click happens inside modal content
    if (evt) {
      if (evt.target.closest('.js-modal-close')) {
        // Do not close if using the modal close button
      } else if (evt.target.closest('.modal__inner')) {
        return;
      }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);
    this.modal.classList.add(this.config.closingClass);

    document.documentElement.classList.remove(...this.config.bodyOpenClass);
    document.documentElement.classList.add(this.config.bodyClosingClass);

    window.setTimeout(function() {
      document.documentElement.classList.remove(this.config.bodyClosingClass);
      this.modal.classList.remove(this.config.closingClass);
      if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
        this.activeSource.setAttribute('aria-expanded', 'false').focus();
      }
    }.bind(this), 500); // modal close css transition

    if (this.isSolid) {
      document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    theme.a11y.removeTrapFocus({
      container: this.modal,
      namespace: 'modal_focus'
    });

    document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    window.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.modal.on('click.modal', this.close.bind(this));
    }
  };

  Modal.prototype.unbindEvents = function() {
    document.documentElement.off('.hero-video-modal ');

    if (this.config.closeOffContentClick) {
      this.modal.off('.hero-video-modal ');
    }
  };

  return Modal;
})();

/*============================================================================
Vimeo
==============================================================================*/

window.vimeoApiReady = function() {
  theme.config.vimeoLoading = true;

  // Because there's no way to check for the Vimeo API being loaded
  // asynchronously, we use this terrible timeout to wait for it being ready
  checkIfVimeoIsReady()
    .then(function() {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      document.dispatchEvent(new CustomEvent('vimeoReady'));
    });
}

function checkIfVimeoIsReady() {
  var wait;
  var timeout;

  var deferred = new Promise((resolve, reject) => {
    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds
  });

  return deferred;
}

theme.VimeoPlayer = (function() {
  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable'
  }

  var defaults = {
    background: true,
    byline: false,
    controls: false,
    loop: true,
    muted: true,
    playsinline: true,
    portrait: false,
    title: false
  };

  function VimeoPlayer(divId, videoId, options) {
    this.divId = divId;
    this.el = document.getElementById(divId);
    this.videoId = videoId;
    this.iframe = null;
    this.options = options;

    if (this.options && this.options.videoParent) {
      this.parent = this.el.closest(this.options.videoParent);
    }

    this.setAsLoading();

    if (theme.config.vimeoReady) {
      this.init();
    } else {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
      document.addEventListener('vimeoReady', this.init.bind(this));
    }
  }

  VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
    init: function() {
      var args = defaults;
      args.id = this.videoId;

      this.videoPlayer = new Vimeo.Player(this.el, args);

      this.videoPlayer.ready().then(this.playerReady.bind(this));
    },

    playerReady: function() {
      this.iframe = this.el.querySelector('iframe');
      this.iframe.setAttribute('tabindex', '-1');

      this.videoPlayer.setMuted(true);

      this.setAsLoaded();

      // pause when out of view
      var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this.iframe);
    },

    setAsLoading: function() {
      if (!this.parent) return;
      this.parent.classList.add(classes.loading);
    },

    setAsLoaded: function() {
      if (!this.parent) return;
      this.parent.classList.remove(classes.loading);
      this.parent.classList.add(classes.loaded);
      if (Shopify && Shopify.designMode) {
        if (window.AOS) {AOS.refreshHard()}
      }
    },

    enableInteraction: function() {
      if (!this.parent) return;
      this.parent.classList.add(classes.interactable);
    },

    play: function() {
      if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
        this.videoPlayer.play();
      }
    },

    pause: function() {
      if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
        this.videoPlayer.pause();
      }
    },

    destroy: function() {
      if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
        this.videoPlayer.destroy();
      }
    }
  });

  return VimeoPlayer;
})();




window.onYouTubeIframeAPIReady = function() {
  theme.config.youTubeReady = true;
  document.dispatchEvent(new CustomEvent('youTubeReady'));
}
/*============================================================================
  YouTube SDK method
  Parameters:
    - player div id (required)
    - arguments
      - videoId (required)
      - videoParent (selector, optional for section loading state)
      - events (object, optional)
==============================================================================*/
theme.YouTube = (function() {
  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable'
  }

  var defaults = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      autoplay: 1,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      rel: 0
    }
  };

  function YouTube(divId, options) {
    this.divId = divId;
    this.iframe = null;

    this.attemptedToPlay = false;

    // API callback events
    defaults.events = {
      onReady: this.onVideoPlayerReady.bind(this),
      onStateChange: this.onVideoStateChange.bind(this)
    };

    this.options = Object.assign({}, defaults, options);

    if (this.options) {
      if (this.options.videoParent) {
        this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
      }

      // Most YT videos will autoplay. If in product media,
      // will handle in theme.Product instead
      if (!this.options.autoplay) {
        this.options.playerVars.autoplay = this.options.autoplay;
      }

      if (this.options.style === 'sound') {
        this.options.playerVars.controls = 1;
        this.options.playerVars.autoplay = 0;
      }

    }

    this.setAsLoading();

    if (theme.config.youTubeReady) {
      this.init();
    } else {
      theme.LibraryLoader.load('youtubeSdk');
      document.addEventListener('youTubeReady', this.init.bind(this));
    }
  }

  YouTube.prototype = Object.assign({}, YouTube.prototype, {
    init: function() {
      this.videoPlayer = new YT.Player(this.divId, this.options);
    },

    onVideoPlayerReady: function(evt) {
      this.iframe = document.getElementById(this.divId); // iframe once YT loads
      this.iframe.setAttribute('tabindex', '-1');

      if (this.options.style !== 'sound') {
        evt.target.mute();
      }

      // pause when out of view
      var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this.iframe);
    },

    onVideoStateChange: function(evt) {
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            this.enableInteraction();
          }
          break;
        case 0: // ended, loop it
          this.play(evt);
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    },

    setAsLoading: function() {
      if (!this.parent) return;
      this.parent.classList.add(classes.loading);
    },

    setAsLoaded: function() {
      if (!this.parent) return;
      this.parent.classList.remove(classes.loading);
      this.parent.classList.add(classes.loaded);
      if (Shopify && Shopify.designMode) {
        if (window.AOS) {AOS.refreshHard()}
      }
    },

    enableInteraction: function() {
      if (!this.parent) return;
      this.parent.classList.add(classes.interactable);
    },

    play: function() {
      if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
        this.videoPlayer.playVideo();
      }
    },

    pause: function() {
      if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
        this.videoPlayer.pauseVideo();
      }
    },

    destroy: function() {
      if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
        this.videoPlayer.destroy();
      }
    }
  });

  return YouTube;
})();


// Init section function when it's visible, then disable observer
theme.initWhenVisible = function(options) {
  var threshold = options.threshold ? options.threshold : 0;

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: '0px 0px '+ threshold +'px 0px'});

  observer.observe(options.element);
};

// init videoSection
theme.VideoSection = (function() {
  var selectors = {
    videoParent: '.video-parent-section'
  };

  function videoSection(container) {
    this.container = container;
    this.sectionId = container.getAttribute('data-section-id');
    this.namespace = '.video-' + this.sectionId;
    this.videoObject;

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 500
    });
  }

  videoSection.prototype = Object.assign({}, videoSection.prototype, {
    init: function() {
      var dataDiv = this.container.querySelector('.video-div');
      if (!dataDiv) {
        return;
      }
      var type = dataDiv.dataset.type;

      switch(type) {
        case 'youtube':
          var videoId = dataDiv.dataset.videoId;
          this.initYoutubeVideo(videoId);
          break;
        case 'vimeo':
          var videoId = dataDiv.dataset.videoId;
          this.initVimeoVideo(videoId);
          break;
        case 'mp4':
          this.initMp4Video();
          break;
      }
    },

    initYoutubeVideo: function(videoId) {
      this.videoObject = new theme.YouTube(
        'YouTubeVideo-' + this.sectionId,
        {
          videoId: videoId,
          videoParent: selectors.videoParent
        }
      );
    },

    initVimeoVideo: function(videoId) {
      this.videoObject = new theme.VimeoPlayer(
        'Vimeo-' + this.sectionId,
        videoId,
        {
          videoParent: selectors.videoParent
        }
      );
    },

    initMp4Video: function() {
      var mp4Video = 'Mp4Video-' + this.sectionId;
      var mp4Div = document.getElementById(mp4Video);
      var parent = mp4Div.closest(selectors.videoParent);

      if (mp4Div) {
        parent.classList.add('loaded');

        var playPromise = document.querySelector('#' + mp4Video).play();

        // Edge does not return a promise (video still plays)
        if (playPromise !== undefined) {
          playPromise.then(function() {
              // playback normal
            }).catch(function() {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
        }
      }
    },

    onUnload: function(evt) {
      var sectionId = evt.target.id.replace('shopify-section-', '');
      if (this.videoObject && typeof this.videoObject.destroy === 'function') {
        this.videoObject.destroy();
      }
    }
  });

  return videoSection;
})();


document.addEventListener('DOMContentLoaded', function() {
  theme.sections = new theme.Sections();
  const videoHeroSectionContainers = document.querySelectorAll('.video-parent-section');
  if (!window.theme.videoHeroSections && videoHeroSectionContainers){
    window.theme.videoHeroSections = []

    theme.videoModal();

    videoHeroSectionContainers.forEach(function(container,index){
      // window.theme.videoHeroSections.push(new theme.VideoSection(container));
      theme.sections.register('video-section',theme.VideoSection);
    });
  }
});
